import React, { PropTypes } from 'react';
import '../../styles/GoldStandardObservations';
import ObservationTable from './ObservationTable';
import { Link } from 'react-router';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

let GoldStandardObservations = React.createClass({
	propTypes: {
		doFlash: PropTypes.func.isRequired,
		fetchObservations: PropTypes.func.isRequired,
		isFetchingObservations: PropTypes.bool,
		observations: PropTypes.array,
		updateObservation: PropTypes.func.isRequired,
	},

	getInitialState: function() {
		return {
			goldStandardIDs: [],
			isUpdating: false
		};
	},

	componentWillMount: function() {
		this.setGoldStandardIDsFromProps(this.props.observations);
		this.props.fetchObservations();
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.observations && newProps.observations.length && propertyHasChanged(newProps.observations, this.props.observations)) {
			this.setGoldStandardIDsFromProps(newProps.observations);
		}
	},

	setGoldStandardIDsFromProps: function(observations) {
		let goldStandardIDs = [];

		if (observations && observations.length) {
			observations.map((observation) => {
				if (observation.is_gold_standard) {
					goldStandardIDs.push(observation.id);
				}
			});
		}

		this.setState({ goldStandardIDs: goldStandardIDs });
	},

	toggleGoldStandard: function(observationID) {
		let { goldStandardIDs } = this.state,
			indexInState = goldStandardIDs.indexOf(observationID);

		if (indexInState > -1) {
			goldStandardIDs.splice(indexInState, 1);
		} else {
			goldStandardIDs.push(observationID);
		}

		this.setState({ goldStandardIDs: goldStandardIDs });
	},

	handleSubmit: function() {
		// Find all observations whose gold standard status has changed
		let { goldStandardIDs } = this.state,
			recordsToUpdate = [];

		this.props.observations.map((observation) => {
			if (observation.is_gold_standard && !goldStandardIDs.includes(observation.id)) {
				// This observation was originally a gold standard but has been toggled off
				recordsToUpdate.push({ id: observation.id, is_gold_standard: false });
			} else if (!observation.is_gold_standard && goldStandardIDs.includes(observation.id)) {
				// This observation was originally not a gold standard but has been toggled on
				recordsToUpdate.push({ id: observation.id, is_gold_standard: true });
			}
		});

		this.setState({ isUpdating: true }, () => {
			let promises = [];

			recordsToUpdate.map((observation) => {
				promises.push(this.props.updateObservation(observation));
			});

			Promise.all(promises).then(() => {
				this.setState({ isUpdating: false }, () => {
					this.props.doFlash('success', 'Success!', 'Your changes have been saved');
				});
			}, () => {
				this.props.doFlash('error', 'Error', 'Your changes were not saved');
			});
		});
	},

	render: function() {
		return(
			<div className="gold-standard-observations container">
				<h2>Gold Standard Observations</h2>
				<p>Click any number of observations in the table below to set them as gold standards for reliability scoring.  When you have made your changes, click the Save button at the bottom of the page.</p>
				<p>Use the search box to the right to filter the list.  You can use multiple search terms as well; for example, &quot;2018-05-29 demo district&quot;</p>
				<ObservationTable
					goldStandardIDs={ this.state.goldStandardIDs }
					isFetching={ this.props.isFetchingObservations }
					items={ this.props.observations }
					handleRowClick={ this.toggleGoldStandard }
				/>
				{
					this.props.observations && this.props.observations.length ? (
						<div className="gold-standard-controls">
							<Link to="/" className="btn btn-default btn-lg">Back</Link>
							{' '}
							<button
								type="button"
								className="btn btn-lg btn-primary"
								onClick={ this.handleSubmit }
								disabled={ this.state.isUpdating }
							>
								{
									this.state.isUpdating ? (
										<span>
											<i className="glyphicon glyphicon-refresh glyphicon-spin" />{' '}Saving
										</span>
									) : (
										<span>
											<i className="glyphicon glyphicon-ok" />{' '}Save
										</span>
									)
								}
							</button>
						</div>
					) : ''
				}
			</div>
		);
	}
});

module.exports = GoldStandardObservations;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/GoldStandardObservations.jsx